import moment from 'moment';
import { CommonSearchParam, ApiBind } from './common-search-param.model';
import { DeliverySetStatus } from '../constants';

export class DeliverySetSearchParam extends CommonSearchParam {
  constructor(
    nameOrId?: string,
    from = moment().startOf('d').toDate(),
    to?: Date,
    placementRelationName?: string,
    statuses?: number[],
    conditions?: number[],
    placementLabels?: string[],
    designTemplateName?: string,
    mediaTypes?: number[],
    deliveryPF?: number,
    testers?: number[],
    textTarget?: string,
    osGroupId?: number,
    deviceModelGroupId?: number,
  ) {
    super();
    this.nameOrId = nameOrId;
    this.scheduleFrom = from;
    this.scheduleTo = to;
    this.placementRelationName = placementRelationName;
    this.statuses = statuses;
    this.conditions = conditions;
    this.placementKeyword = placementLabels;
    this.designTemplateName = designTemplateName;
    this.mediaTypes = mediaTypes;
    this.deliveryPF = deliveryPF;
    this.testers = testers;
    this.textTarget = textTarget;
    this.osGroupId = osGroupId;
    this.deviceModelGroupId = deviceModelGroupId;
  }

  @ApiBind({ column: 'name_or_id' })
  nameOrId: string;

  @ApiBind({ column: 'schedule_from' })
  scheduleFrom: Date;

  @ApiBind({ column: 'schedule_to' })
  scheduleTo: Date;

  @ApiBind({ column: 'placement_relation_name' })
  placementRelationName: string;

  @ApiBind({ column: 'statuses' })
  statuses: number[];

  @ApiBind({ column: 'delivery_conditions' })
  conditions: number[];

  @ApiBind({ column: 'placement_keywords' })
  placementKeyword: string[];

  @ApiBind({ column: 'design_template_name' })
  designTemplateName: string;

  @ApiBind({ column: 'media_types' })
  mediaTypes: number[];

  @ApiBind({ column: 'delivery_pf' })
  deliveryPF: number;

  @ApiBind({ column: 'testers' })
  testers: number[];

  @ApiBind({ column: 'text_target' })
  textTarget: string;

  @ApiBind({ column: 'os_group_id' })
  osGroupId: number;

  @ApiBind({ column: 'device_model_group_id' })
  deviceModelGroupId: number;
}
